/**
 * @generated SignedSource<<3e480af25631b8761ee57256892f1753>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateExchangeRateInput = {
  currency?: string | null;
  rate?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateExchangeRateMutation$variables = {
  input: CreateExchangeRateInput;
};
export type CreateExchangeRateMutation$data = {
  readonly createExchangeRate: {
    readonly exchangeRate: {
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly startDate: string | null;
        readonly isUsed: boolean | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateExchangeRateMutation$rawResponse = {
  readonly createExchangeRate: {
    readonly exchangeRate: {
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly startDate: string | null;
        readonly isUsed: boolean | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateExchangeRateMutation = {
  variables: CreateExchangeRateMutation$variables;
  response: CreateExchangeRateMutation$data;
  rawResponse: CreateExchangeRateMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExchangeRatePayload",
    "kind": "LinkedField",
    "name": "createExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExchangeRateTypeEdge",
        "kind": "LinkedField",
        "name": "exchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf08ac5b4d7705367b959387f6224296",
    "id": null,
    "metadata": {},
    "name": "CreateExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation CreateExchangeRateMutation(\n  $input: CreateExchangeRateInput!\n) {\n  createExchangeRate(input: $input) {\n    exchangeRate {\n      node {\n        id\n        currency\n        rate\n        startDate\n        isUsed\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "35e23ca27cdaf102377d3aeb4938444d";

export default node;
